import { Component, Input } from '@angular/core';
import { ChatWindowComponent } from '../chat-window.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-launch-chat-support-button',
  templateUrl: './launch-chat-support-button.component.html',
  standalone: false,
})
export class LaunchChatSupportButtonComponent {
  @Input() conversationId: string = '';

  constructor(private dialog: MatDialog) {}

  public openChat() {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      conversationId: this.conversationId,
      role: 'support',
    };
    // TODO (jacob): How do I make this larger?
    dialogConfig.hasBackdrop = false; // this makes it non-modal
    dialogConfig.panelClass = 'custom-dialog-container';

    this.dialog.open(ChatWindowComponent, dialogConfig);
  }
}
